// this mixin provides a beforeRouteEnter guard and redirects to SignIn/info or SignIn/disclaimers accordingly

import { mapGetters, mapActions } from 'vuex';
import { LoggerService } from '@/services';

export default {
  computed: {
    ...mapGetters({
      investorAllowed: 'qualification/investorAllowed',
      missingDisclaimers: 'qualification/missingDisclaimers',
      noDisclaimer: 'qualification/noDisclaimer',
      isLoggedIn: 'tokeny/isLoggedIn'
    }),
    profileComplete () {
      return this.investorAllowed === 'OK' &&
        this.missingDisclaimers &&
        Array.isArray(this.missingDisclaimers) &&
        this.missingDisclaimers.length === 0;
    }
  },
  methods: {
    ...mapActions({
      fetchInvestorAllowed: 'qualification/fetchInvestorAllowed',
      fetchMissingDisclaimers: 'qualification/fetchMissingDisclaimers',
      setNoDisclaimer: 'qualification/setNoDisclaimer',
      saveDisclaimers: 'qualification/saveDisclaimers'
    })
  },
  beforeRouteEnter (_to, _from, next) {
    next(async (vm) => {
      if (!vm.isLoggedIn) return;
      // guardInvestorAllowed
      if (vm.investorAllowed === null) {
        try {
          await vm.fetchInvestorAllowed();
        } catch (error) {
          LoggerService.error(error);
        }
      }

      // handles things like ERROR_COUNTRY_NOT_ALLOWED
      if (vm.investorAllowed !== 'OK') {
        if (vm.investorAllowed === 'ERROR_COUNTRY_NOT_ALLOWED') {
          vm.$router.replace({ name: 'banned-country' });
          return false;
        } else if (vm.investorAllowed === 'ERROR_IDENTITY_NOT_COMPLETE') {
          vm.$router.replace({ name: 'sign-in-info' });
          return false;
        } else {
          LoggerService.error({ code: vm.investorAllowed });
          await vm.signOut();
          return false;
        }
      }

      // guardMissingDisclaimers
      try {
        await vm.fetchMissingDisclaimers();
      } catch (error) {
        LoggerService.error(error);
        await vm.signOut();
        return false;
      }

      if (vm.missingDisclaimers.length > 0) {
        vm.$router.replace({ name: 'sign-in-disclaimers' });
        return false;
      }

      if (vm.noDisclaimer === true) {
        try {
          await vm.saveDisclaimers({ disclaimers: [] });
          await vm.setNoDisclaimer(false);
        } catch (error) {
          LoggerService.error(error);
          await vm.signOut();
          return false;
        }
      }
    });
  }
};
